import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TipoUsuarioService } from "src/app/servicios/tipo-usuario.service";
import { UsuarioService } from "src/app/servicios/usuario.service";
import { AgenciaService } from "src/app/servicios/agencia.service";

@Component({
  selector: "app-modificar-usuario-persona",
  templateUrl: "./modificar-usuario-persona.component.html",
  styleUrls: ["./modificar-usuario-persona.component.css"]
})
export class ModificarUsuarioPersonaComponent implements OnInit {
  @Output()
  propagar = new EventEmitter<string>();

  @Input() dataModificaUsuario: any;
  usuarioGrupo: FormGroup;
  tiposUsuario = [];
  loadingUsuario = false;
  agencias = [];

  constructor(
    private fb: FormBuilder,
    private servicioTiposUsuario: TipoUsuarioService,
    private servicioUsuario: UsuarioService,
    private servicioAgencia: AgenciaService,
    private snackBar: MatSnackBar
  ) {
    //console.log(this.dataModificaUsuario);
    this.usuarioGrupo = this.fb.group({
      IdUsuario: [""],
      IdTpoUsuario: ["", [Validators.required]],
      Usuario: ["", [Validators.required, Validators.maxLength(250)]],
      Clave: ["", [Validators.required, Validators.maxLength(250)]],
      Descripcion: ["", [Validators.maxLength(250)]],
      formAgencias: ["", [Validators.required]]
    });

    this.servicioAgencia.getAllAgencia(0).subscribe(result => {
      this.agencias = result;
    });
  }

  ngOnInit() {
    this.refreshData();
  }

  ngOnChanges() {
    this.refreshData();
  }

  setValuesForm() {
    const agenciaArr = Array.from(
      this.dataModificaUsuario.agencias.split(",")
    ).map(item => Number(item));
    this.usuarioGrupo.controls["IdUsuario"].setValue(
      this.dataModificaUsuario.IdUsuario
    );
    this.usuarioGrupo.controls["IdTpoUsuario"].setValue(
      this.dataModificaUsuario.IdTpoUsuario
    );
    this.usuarioGrupo.controls["Usuario"].setValue(
      this.dataModificaUsuario.Usuario
    );
    this.usuarioGrupo.controls["Clave"].setValue(
      this.dataModificaUsuario.Clave
    );
    this.usuarioGrupo.controls["Descripcion"].setValue(
      this.dataModificaUsuario.Descripcion
    );
    this.usuarioGrupo.controls["formAgencias"].setValue(agenciaArr);
  }

  refreshData() {
    this.loadingUsuario = true;
    this.servicioTiposUsuario.getTiposUsuario().subscribe(result => {
      this.tiposUsuario = result;
      this.loadingUsuario = false;
      this.setValuesForm();
    });
  }

  eliminarUsuario() {}

  submitForm() {
    let usuario = this.usuarioGrupo.value;

    usuario.Descripcion = usuario.Descripcion.toUpperCase();
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario')); 

    let agenciasLista = "";
    usuario.formAgencias.forEach(element => {
      agenciasLista = agenciasLista + element + ",";
    });
    agenciasLista = agenciasLista.slice(0, -1);
    usuario.formAgencias = agenciasLista;
    
    usuario.usuarioActualiza=infoUsuario[0].IdUsuario;
    //console.log(JSON.stringify(usuario));
    //return;
    this.servicioUsuario.putUsuario(usuario).subscribe(result => {
      this.propagar.emit(this.dataModificaUsuario);
      //console.log("aqui es");
      this.snackBar.open("Usuario Actualizado", "Actualizar Usuario", {
        duration: 2000
      });
    });
  }
}
